import type { DocMeta } from '@blocksuite/affine/store';
import type * as Y from 'yjs';
import type { FrameworkProvider } from '@toeverything/infra';

import { WorkspaceMetaImpl } from './meta';

export class EnhancedWorkspaceMetaImpl extends WorkspaceMetaImpl {
  private readonly framework?: FrameworkProvider;

  constructor(doc: Y.Doc, framework?: FrameworkProvider) {
    super(doc);
    this.framework = framework;
  }

  async handleTitleUpdate(
    id: string,
    props: Partial<DocMeta>
  ): Promise<string> {
    try {
      // 延迟导入和获取服务，避免循环依赖
      const { DocTitleUniquenessService, OrganizeService } = await import(
        '../../organize'
      );

      const docTitleUniquenessService = this.framework?.get(
        DocTitleUniquenessService
      );
      const organizeService = this.framework?.get(OrganizeService);

      const { title, ...otherProps } = props;

      // 获取文档所在的文件夹节点
      const node = organizeService?.folderTree.folderNodeByDocId$(id).value;
      let parentNode = organizeService?.folderTree.rootFolder;

      if (node) {
        const nodeInfo = node.info$.value;
        const parentId = nodeInfo?.parentId;
        if (parentId) {
          const parentNodeValue =
            organizeService.folderTree.folderNode$(parentId)?.value;
          if (parentNodeValue) {
            parentNode = parentNodeValue;
          }
        }
      }

      // 确保标题唯一性
      const finalTitle =
        docTitleUniquenessService?.ensureUniqueTitleInFolderWithoutChange(
          id,
          parentNode as any,
          title
        );

      super.setDocMeta(id, { title: finalTitle });

      return finalTitle || '';
    } catch (error) {
      console.warn('Failed to ensure title uniqueness:', error);
      // 出错时使用默认实现
      super.setDocMeta(id, props);
      return props.title || '';
    }
  }
}
